import React from 'react';

const Index = () => {
  return (
    <>
      <svg viewBox="0 0 12.7 12.7" xmlns="http://www.w3.org/2000/svg" style={{transform: "scale(1.7)"}}>
        <path
          d="m3.88 287.122-1.058 1.059 2.47 2.469-2.47 2.47 1.059 1.058 2.469-2.47 2.47 2.47 1.058-1.059-2.47-2.469 2.47-2.47-1.059-1.058-2.469 2.47z"
          transform="translate(0 -284.3)" color="#000000" fontStyle="normal"
          fontVariant="normal" fontWeight="400" fontStretch="normal"
          fontSize="medium" fontFamily="sans-serif" textDecoration="none"
          letterSpacing="normal" wordSpacing="normal" writingMode="lr-tb"
          direction="ltr" dominantBaseline="auto" baselineShift="baseline"
          textAnchor="start" clipRule="nonzero" display="inline"
          overflow="visible" visibility="visible" opacity="1"
          colorInterpolation="sRGB" colorInterpolationFilters="linearRGB"
          vectorEffect="none" fill="#d72c0d" fillOpacity="1"
          fillRule="evenodd" stroke="none" strokeWidth="1.41111135"
          strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="4"
          strokeDasharray="none" strokeDashoffset="0" strokeOpacity="1"
          colorRendering="auto" imageRendering="auto" shapeRendering="auto"
          textRendering="auto" enableBackground="accumulate"
          className="fill-000000"></path>
      </svg>
    </>
  );
};

export default Index;
